/*
  Renderer for the cancellation-release response. Shown inline below the
  validation panel once the operator presses Release selected.
*/
import React from 'react';
import { Col, Empty, Row, Space, Statistic, Table, Tag, Typography } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { isValid, isValidArray } from '../../utils/utilities';

const { Text } = Typography;

export const renderReleaseResults = (releaseResults) => {
    if (!releaseResults) {
        return null;
    }
    const cancellations = isValidArray(releaseResults.cancellations) ? releaseResults.cancellations : [];
    if (cancellations.length === 0) {
        return <Empty description="No cancellations were processed." />;
    }
    return (
        <Space direction="vertical" style={{ width: '100%' }} size={16}>
            <Row gutter={[16, 16]}>
                <Col xs={12} md={4}>
                    <Statistic title="Cancellations attempted" value={releaseResults.summary.totalCancellations} />
                </Col>
                <Col xs={12} md={4}>
                    <Statistic title="Released" value={releaseResults.summary.releasedTickets} valueStyle={{ color: '#52c41a' }} />
                </Col>
                <Col xs={12} md={4}>
                    <Statistic title="Failed" value={releaseResults.summary.failedCancellations} valueStyle={{ color: '#ff4d4f' }} />
                </Col>
            </Row>
            <Table
                rowKey={(record) => `release-${record.tripKey}__${record.pnr}`}
                pagination={{ pageSize: 10 }}
                scroll={{ x: 'max-content' }}
                size="small"
                dataSource={cancellations}
                columns={[
                    { title: 'Journey Date', dataIndex: 'journeyDate', key: 'journeyDate', width: 110 },
                    { title: 'Service', dataIndex: 'serviceNumber', key: 'serviceNumber', width: 170 },
                    { title: 'Original PNR', dataIndex: 'pnr', key: 'pnr', width: 120 },
                    {
                        title: 'Result',
                        key: 'result',
                        width: 130,
                        render: (_v, r) => (
                            r.success
                                ? <Tag color="green" icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}>Released</Tag>
                                : <Tag color="red" icon={<CloseCircleTwoTone twoToneColor="#ff4d4f" />}>Failed</Tag>
                        ),
                    },
                    {
                        title: 'Released Ticket Id',
                        dataIndex: 'releasedTicketId',
                        key: 'releasedTicketId',
                        width: 150,
                        render: (value) => (isValid(value) ? <Text code>#{value}</Text> : <Text type="secondary">—</Text>),
                    },
                    { title: 'Reason', dataIndex: 'reason', key: 'reason' },
                ]}
            />
        </Space>
    );
};
